<template>
	<div v-if="show" @click.self="dismissModal()" class="fixed pin z-50 overflow-hidden bg-smoke-light flex">
		<div class="relative bg-grey-lightest w-full max-w-lg m-auto flex-col flex rounded m-8 overflow-hidden max-h-screen-90 ">
			<div class="w-full bg-green-light py-1"></div>
			<div class="flex py-2 m-2 px-4">
				<div class="flex-1 text-left">
					<p class="text-lg font-extrabold">Lägg till bild</p>
				</div>
				<div class="flex-1 mr-2">
					<button @click="dismissModal()" class="float-right text-grey hover:text-grey-darker">
						<svg class="fill-current h-5 w-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/></svg>
					</button>
				</div>
			</div>

			<div class="pb-8">
				<vue-dropzone  class="mx-8 mb-4" ref="vueDropzone" id="dropzone" :options="dropzoneOptions" @vdropzone-success="imageUploaded" @vdropzone-error="uploadError"></vue-dropzone>

				<p class="font-semibold" v-text="image_ids.length ? 'Sparade bilder' : 'Inga bilder tillagda än'" ></p>
				<div class="mx-4 p-4 mt-2 flex flex-wrap content-start max-h-screen-40 overflow-scroll">
					<div class="w-1/3 mb-4" v-for="id in image_ids" :key="id">
						<div class="w-5/6 inline-flex img-dimensions bg-white rounded mb-2 px-2 border border-grey-light">
							<img class="img-max-dimensions rounded self-center mx-auto" :src="getImageUrl(id)">
						</div>
						<button class="bg-green-light hover:bg-green text-grey-darkest font-bold py-1 px-6 mx-2 rounded" @click="addImageToCanvas(id)">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19.5 12c-2.483 0-4.5 2.015-4.5 4.5s2.017 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.017-4.5-4.5-4.5zm2.5 5h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1zm-18 0l4-5.96 2.48 1.96 2.52-4 1.853 2.964c-1.271 1.303-1.977 3.089-1.827 5.036h-9.026zm10.82 4h-14.82v-18h22v7.501c-.623-.261-1.297-.422-2-.476v-5.025h-18v14h11.502c.312.749.765 1.424 1.318 2zm-9.32-11c-.828 0-1.5-.671-1.5-1.5 0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5c0 .829-.672 1.5-1.5 1.5z"/></svg>
						</button>
						<button class="bg-grey-light hover:bg-grey text-grey-darkest font-bold py-1 px-6 mx-2 rounded" @click="deleteImage(id)">
							<svg class="w-5 fill-current text-red" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M3 6v18h18v-18h-18zm5 14c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm5 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm5 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm4-18v2h-20v-2h5.711c.9 0 1.631-1.099 1.631-2h5.315c0 .901.73 2 1.631 2h5.712z"/></svg>
						</button>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import axios from 'axios'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { mapGetters } from 'vuex'

export default {

	components: {
		vueDropzone: vue2Dropzone
	},

	data() {
		return {
			show: false,
			page_id: null,

			image_ids: [],
		}
	},

	computed: {

		...mapGetters({
			customer:		'customer/customer',
			token:			'auth/access_token',
		}),

		dropzoneOptions() {
			return {
				url: this.axios.defaults.baseURL + '/print/image/',
                headers: {
					"Authorization": this.token
				},
				acceptedFiles: "image/*",
				thumbnailMethod: 'contain',
                dictDefaultMessage: "Släpp en bild eller klicka här!"
			}
		}
	},

	mounted() {
		bus.$on('open-add-image-modal', this.openModal)
		bus.$on('close-add-image-modal', this.dismissModal)

		this.retrieveImages()
	},

    beforeDestroy() {
        bus.$off('open-add-image-modal')
        bus.$off('close-add-image-modal')
    },

	methods: {
		openModal(page_id = null) {
			this.page_id = page_id
			this.show = true
			document.getElementById("body").className = "overflow-y-hidden";
			bus.$emit('deselect')
		},
		
		dismissModal() {
			this.show = false
			document.getElementById("body").className = "";
		},
		
		imageUploaded(image, response) {
			this.$refs.vueDropzone.removeFile(image)
			this.image_ids.unshift(response)
		},

		uploadError(file, message, xhr) {
			console.log(message)
		},

		retrieveImages() {
			axios.get('/print/image')
			.then(response => {
				this.image_ids = response.data
			})
		},

		getImageUrl(id) {
			return this.axios.defaults.baseURL + '/print/image/' + id
		},

		deleteImage(id) {
			if(confirm("Vill ta bort bilden från dina uppladdade bilder?")) {
				axios.delete('/print/image/' + id)
				.then(response => {
					this.image_ids.splice(this.image_ids.findIndex(img_id => img_id == id), 1)
				})
			}
		},

		addImageToCanvas(id) {
			bus.$emit('add-image-to-canvas', this.page_id, id)
		}
	}
}
</script>